export var focusCapture = 'QvSg_';
export var dividerOpacity = '_32DTE';